import { adminActionButtonSx } from 'src/theme/adminActionButton';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, Typography, Stack } from '@mui/material';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { forgotPassword } from 'src/helper/backend_helper';

export default function StepEnterEmail({ onNext }) {
  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email').required('Email is required')
    }),
    onSubmit: async (values) => {
      try {
        const response = await forgotPassword(values, {});

        // TODO: send OTP to email via backend API
        // toast.success('OTP sent to your email');
        onNext(values.email, response.authMode);
      } catch (err) {
        console.error(err);
        toast.error('Failed to send OTP. Please try again.');
      }
    }
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack spacing={2}>
        <Typography variant="h6"></Typography>
        <TextField
          size="small"
          label="Email"
          name="email"
          fullWidth
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        {/* <Button type="submit" variant="contained" color="primary">
          Send OTP
        </Button> */}

        <LoadingButton
          fullWidth
          size="small"
          type="submit"
          variant="contained"
          //   onClick={() => handleLogin}
          loading={formik.isSubmitting}
          sx={{
            ...adminActionButtonSx
          }}
        >
          Send OTP
        </LoadingButton>
      </Stack>
    </form>
  );
}
